import React from "react";
import "../../css_files/Enquiry/EnquiryCard.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api";

function EnquiryCard({
  setEnquiryId,
  setshowenquiryInfo,
  setenquiryinfodata,
  infodata,
}) {
  const nav = useNavigate();
  return (
    <section className="enquiry-card">
      <div>
        <aside>
          <blockquote>
            <mark>
              <b>Ticket Created: </b>
              <i
                className={`fa-solid ${
                  infodata.isTicketCreated ? "fa-check" : "fa-xmark"
                }`}
              ></i>
            </mark>

            <mark>
              <b>Priority: </b>
              <span>{infodata.priority}</span>
            </mark>
          </blockquote>

          <blockquote>
            <mark>
              <i class="fa-regular fa-building"></i>
              <p>{infodata.customer.orgName}</p>
            </mark>
          </blockquote>
          <blockquote>
            <mark>
              <i class="fa-regular fa-user-circle"></i>
              <p>{infodata.contactCentre.name}</p>
            </mark>
          </blockquote>
          <blockquote>
            <mark>
              <i className="fa-solid fa-envelope"></i>
              <p>{infodata.contactCentre.email}</p>
            </mark>
          </blockquote>
          <blockquote>
            <mark>
              <i class="fa-solid fa-calendar-days"></i>
              <p>{new Date(infodata.dateOfEnquiry).toLocaleDateString()}</p>
            </mark>
            <mark>
              <i class="fa-solid fa-phone"></i>
              <p>{infodata.contactCentre.phoneNumber}</p>
            </mark>
          </blockquote>
          <blockquote>
            <mark>
              <i class="fa-solid fa-location-dot"></i>
              <p>
                {infodata.shipToAddress.address1 +
                  ", " +
                  infodata.shipToAddress.address2 +
                  ", " +
                  (infodata.shipToAddress?.cityObj?.name ||
                    infodata.shipToAddress?.cityName) +
                  ", " +
                  (infodata.shipToAddress?.stateObj?.name ||
                    infodata.shipToAddress?.stateName) +
                  ", " +
                  infodata.shipToAddress.country +
                  ", " +
                  infodata.shipToAddress.pincode}
              </p>
            </mark>
          </blockquote>
        </aside>
      </div>
      <div>
        <aside>
          <blockquote>
            <p>{infodata.seriesID}</p>
            <a
              href="#"
              onClick={() => {
                if (infodata.isTicketCreated) {
                  setshowenquiryInfo(true);
                  setenquiryinfodata(infodata);
                } else {
                  setEnquiryId(infodata.seriesID);
                  nav("/dashboard/checkin/steps/step1");
                }
              }}
            >
              View Details
            </a>
          </blockquote>
        </aside>
      </div>
    </section>
  );
}

export default EnquiryCard;
